module.exports = __webpack_public_path__ + "distVue/img/appDownQrCode.97682b40.png";